import {useState} from "react";
import {login, getIdToken} from "../../services/auth";
import {ProcessLogin} from "../ApiRequester.jsx";
import dklogo from "../../img/PCLC.svg";
import {Link} from 'react-router-dom';

const LoginForm = () => {

    const [formObj, setForm] = useState({
        username: "",
        password: "",
        errMsg: "",
    })

    async function loginSubmit(){
        document.getElementById("loadSubmit").classList.remove("d-none");
        document.getElementById("subBtn").classList.add("d-none");

        try {
            // Step 1: Authenticate directly with Cognito via Amplify.
            // Trim the username so autofill / paste-induced whitespace doesn't
            // trip Cognito's userName regex (`[\p{L}\p{M}\p{S}\p{N}\p{P}]+`),
            // which surfaces as a confusing "2 validation errors detected"
            // message instead of a normal incorrect-credentials response.
            // Password is intentionally NOT trimmed — leading/trailing spaces
            // are valid password characters and stripping them would silently
            // change what the user typed.
            const cleanUsername = (formObj.username || '').trim();
            const authResult = await login(cleanUsername, formObj.password);

            if (!authResult.success) {
                // Handle auth challenges (e.g. NEW_PASSWORD_REQUIRED)
                if (authResult.challenge?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
                    setForm(prevState => ({...prevState,
                        errMsg: "Password change required. Please contact your administrator."}));
                } else {
                    setForm(prevState => ({...prevState,
                        errMsg: authResult.error || "Invalid Username and Password"}));
                }
                document.getElementById("loadSubmit").classList.add("d-none");
                document.getElementById("subBtn").classList.remove("d-none");
                return;
            }

            // Step 2: Fetch session/app data from the JWT-protected /session endpoint
            const idToken = await getIdToken();
            const baseUrl = import.meta.env.VITE_DEVMODE === "true"
                ? import.meta.env.VITE_DEVAPI
                : import.meta.env.VITE_API;

            const response = await fetch(baseUrl + "/session", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                },
            });

            // API Gateway returns 503 when it can't reach the upstream Lambda
            // (cold-start timeout, integration timeout, etc). Surface a clearer
            // message than the generic "Login failed" so users know to retry.
            if (response.status === 503) {
                setForm(prevState => ({...prevState,
                    errMsg: "The login service is temporarily unavailable. Please try again in a moment."}));
                document.getElementById("loadSubmit").classList.add("d-none");
                document.getElementById("subBtn").classList.remove("d-none");
                return;
            }

            const resp = await response.json();

            // Step 3: Process the session data (builds dData/PAL blob)
            ProcessLogin(resp, {Username: cleanUsername}, {setMsg: {setForm}});

        } catch (err) {
            console.error('[LoginForm] Login error:', err);
            setForm(prevState => ({...prevState,
                errMsg: "Login failed. Please try again."}));
            document.getElementById("loadSubmit").classList.add("d-none");
            document.getElementById("subBtn").classList.remove("d-none");
        }
    }

    return (
        <div className="auth-card">
            <img src={dklogo} alt="PalCare Logo" className="auth-card__logo" />
            <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
                <div className="auth-field">
                    <label className="auth-field__label" htmlFor="Username">Username</label>
                    <input
                        id="Username"
                        type="text"
                        name="Username"
                        className="auth-field__input"
                        placeholder="Enter your username"
                        autoComplete="username"
                        tabIndex={0}
                        onChange={e => {
                            const userEntered = e.target.value;
                            setForm(prevState => ({...prevState, username: userEntered}));
                        }}
                    />
                </div>
                <div className="auth-field">
                    <label className="auth-field__label" htmlFor="Password">Password</label>
                    <div className="auth-field__input-group">
                        <input
                            type="password"
                            name="Password"
                            id="Password"
                            className="auth-field__input"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                            onChange={e => {
                                const passEntered = e.target.value;
                                setForm(prevState => ({...prevState, password: passEntered}));
                            }}
                            onKeyUp={e => {
                                if (e.key === "Enter"){
                                    document.getElementById("subBtn").click();
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="auth-field__eye-toggle"
                            tabIndex={-1}
                            onClick={() => {
                                const eyeIcon = document.getElementById("passwordEyeIcon");
                                const passfield = document.getElementById("Password");
                                if (passfield.type === "password"){
                                    passfield.type = "text";
                                    eyeIcon.className = "fe fe-eye";
                                }else{
                                    passfield.type = "password";
                                    eyeIcon.className = "fe fe-eye-off";
                                }
                            }}
                        >
                            <i id="passwordEyeIcon" className="fe fe-eye-off" />
                        </button>
                    </div>
                </div>

                {formObj.errMsg && (
                    <div className="auth-error">{formObj.errMsg}</div>
                )}

                <button
                    type="button"
                    className="auth-btn-primary d-none"
                    disabled={true}
                    id="loadSubmit"
                >
                    <span className="auth-spinner" /> Signing in...
                </button>
                <button
                    type="button"
                    className="auth-btn-primary"
                    id="subBtn"
                    onClick={() => loginSubmit()}
                >
                    Sign In
                </button>

                <div style={{textAlign: "center"}}>
                    <Link to="/recovery" className="auth-link">Forgot Password?</Link>
                </div>
            </form>
        </div>
    );
};

export default LoginForm;
